
export default function Configs(that) {

    const tableColumns = [
        {
            label: "事项名称",
            prop: "linkName",
            align: "center",
            show: true
        },
        {
            label: "事项说明",
            prop: "description",
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '200px',
            show: true
        }
    ]

    const formItems = [
        {
            label: "事项名称",
            span: 24,
            placeholder: '请输入事项名称',
            model: "linkName",
            labelClass: 'info-label',
        },
        {
            label: "事项说明",
            span: 24,
            placeholder: '请输入事项说明',
            model: "description",
            type: 'textarea',
            labelClass: 'info-label',
        },
    ]

    const formRules = {
        linkName: [{
            required: true,
            trigger: "blur",
            message: '请输入事项名称'
        }],
        description: [{
            required: true,
            trigger: "blur",
            message: '请输入事项说明'
        },
        {
            max: 200,
            trigger: "blur",
            message: '最大长度200个字符'
        }],
    }

    return {
        tableColumns,
        formItems,
        formRules
    }
}
